import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Modal } from 'react-bootstrap'

import base from 'Styles/base.css'
import style from './style.css'

import closeIcon from 'Assets/x-icon-gray.svg'

function HowIsCalculatedModal (props) {
  return (
    <Modal show={true}>
      <div className={style.containerModal}>
        <Modal.Header>
          <button
            data-test-id="closeEditTopics"
            aria-label="Close Edit Topics"
            className={classnames(style.closeEditTarget, style.hideModal)}
            onClick={props.onClose}
            tabIndex="0"
          >
            <object
              data={closeIcon} type="image/svg+xml"
              className={base.svgIcon}
              tabIndex="-1"
            />
          </button>
          <Modal.Title className={style.title}>
            {`How ${props.type} Time is Calculated`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={style.text} tabIndex="0">
          {props.type === 'Estimated'
            ? 'This is an estimate of the average time it takes a student to reach the default target score for this activity. It is calculated by averaging session times of students across the country, excluding long periods of idle time. It does not include activities with customized target scores or topics.'
            : 'This is the average time students in your class are taking to reach the target score for this activity. It is calculated by averaging the session times of your students, excluding long periods of idle time.'
          }
        </Modal.Body>
        <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
          <button
            className={classnames('btn-cdl-main', style.btnClose)}
            onClick={props.onClose}
          >
            Got It!
          </button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

HowIsCalculatedModal.propTypes = {
  type: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}

export default HowIsCalculatedModal
